module.exports = __webpack_public_path__ + "fe990f0633a16121db07a88a65858aee.woff2";